export const truthyItems = <T>(item: T | undefined): item is T => !!item;

export const createNewUniqueArray = <T>(array: T[], newItem: T): T[] =>
	Array.from(new Set([...array, newItem]));

export const mapIdsToObjects = <T extends { id: string }>(ids: string[], list: T[]): T[] =>
	ids.map((id) => list.find((item) => item.id === id)).filter(truthyItems);
